@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-list-layout-workflows-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [listLayout]="_context.formContext.item"
                (listLayoutUpdated)="onListLayoutUpdated($event)"
                (canceled)="onCanceled($event)"></app-list-layout-workflows-form>
        </mat-tab>
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Colonnes">
                <app-list-layout-workflows-columns-form
                    [context]="_context.formContext"
                    (listLayoutUpdated)="onListLayoutUpdated($event)"
                    [sizeInPercent]="_context.formContext.item.isScreenSizeAdapted"
                    [sortEnabled]="true"
                    (canceled)="onCanceled($event)"></app-list-layout-workflows-columns-form>
            </mat-tab>
        }
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Mise en page par défaut">
                <app-list-layout-workflows-accessibility-form
                    [listLayout]="_context.formContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-list-layout-workflows-accessibility-form>
            </mat-tab>
        }
    </mat-tab-group>
}
